import { LikeType } from "@/types/LikeType";
import http from "./httpService";
import Cookies from "js-cookie";

export function LikeProduct({ customerId, variantId }: LikeType) {
  const token = Cookies.get("AccessToken");

  return http
    .post(
      "/ProductApi/ToggleLikeProduct",
      {
        customerId,
        variantId,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    )
    .then(({ data }) => data);
}
